import axios from "axios";

const deleteCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Strict`;
};

export const handleSignout = async () => {
  try {
    await axios.get(
      process.env.REACT_APP_BASEURL + "user-service-and-maintenance/logout",
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
  } catch (error) {
    console.log("Logout Error", error);
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    deleteCookie("userData");
    deleteCookie("token");
  }
};
